import { api } from "../services/Api";

export const fetchUser = () => {
  return api.get(`/users/@me`);
};
